import { Flex, Text } from '@chakra-ui/react';

const DisplayBox = ({ text }: { text?: string | number }) => {
  return (
    <Flex
      top="230px"
      left="50%"
      transform="translate(-50%, -50%)"
      position="absolute"
      zIndex={2}
      bg="clayDark"
      width="160px"
      height="46px"
      justifyContent="center"
      alignItems="center"
      paddingTop="12px"
      pointerEvents="none"
    >
      <Flex
        bg="pictonBlue"
        justifyContent="center"
        alignItems="center"
        width="65%"
        height="100%"
        fontSize="3xl"
        lineHeight="3xl"
        fontWeight="bold"
        fontFamily="digital"
        letterSpacing="0.05em"
      >
        <Text
          color="rgba(0,0,0, 0.02)"
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          paddingTop="11px"
        >
          8888888
        </Text>
        <Text letterSpacing="0.05em">{text}</Text>
      </Flex>
    </Flex>
  );
};

export default DisplayBox;
